import { convertCRMDate } from "../../helper";
import { mapClaimStatus } from "../user/helper";
import { ClaimState, ClaimItemDamage, ClaimItem, Documents } from "./types";

export const mapApiClaim = (payload: any): ClaimState => {
  return {
    id: payload["id"],
    claimNumber: payload["fpp_original_number"] || payload["Name"],
    email: payload["contact"]?.["Email"] || "",
    phoneNumber:
      payload["contact"]?.["Home_Phone"] ||
      payload["contact"]?.["Mobile"] ||
      "",
    city: payload["contact"]?.["Mailing_City"] || "",
    state: payload["contact"]?.["Mailing_State"] || "",
    address1: payload["contact"]?.["Mailing_Street"] || "",
    address2: payload["contact"]?.["Mailing_Street_2"] || "",
    zip: payload["contact"]?.["Mailing_Zip"] || "",
    WarrantyProgramName:
      payload["warranty"]?.["Warranty_Programs"]?.["name"] || "",
    claimFileDate: payload["claim_date"],
    planNumber:
      payload["warranty"]?.["Name"] || payload["warranty"]?.["name"] || "",
    dealerName: payload["Dealer"]?.["name"] || "",
    purchaseDate: convertCRMDate(payload["warranty"]?.["purchase_date"]),
    deliveryDate: convertCRMDate(payload["warranty"]?.["delivery_date"]),
    planAgreement: payload["warranty"]?.["T_C_File_URL"] || "",
    claimItems: payload["claim_items"]
      ? payload["claim_items"].map(mapApiClaimItems)
      : [],
    status_code: payload["status_code"] || "",
    status: mapClaimStatus(payload["bp_status"]),
    denied: !!payload["denied"],
    documents: payload["documents"]
      ? payload["documents"].map(mapApiDocuments)
      : [],
    customerName:
      payload["Contact"]?.["Name"] || payload["Contact"]?.["name"] || "",
    emails: payload["emails"] || [],
    customerActionDetail: payload["customer_action_detail"] || "",
  };
};

const mapApiClaimItems = (data: any = {}): ClaimItem => ({
  id: data?.id,
  status: data?.["status_customer_display"] || "",
  claim_item_name: data?.["Name"] || "",
  manufacturer: data?.["manufacturer"] || "",
  color: data?.["color"] || "",
  material: data?.["material"] || "",
  vendor: data?.["warrantyItem"]?.["vendor"] || "",
  description: data?.["warrantyItem"]?.["item_descr"] || "",
  damages: data["damages"] ? data["damages"].map(mapApiClaimItemDamages) : [],
});

const mapApiClaimItemDamages = (data: any = {}): ClaimItemDamage => ({
  damage_category: data?.["damage_type"] || "",
  specific_damage: data?.["specific_damage"] || "",
  damage_Area: data?.["specific_location"] || "",
  when_did_it_happen: data?.["da_damage_date"] || null,
  how_did_it_happen: data?.["how_did_occur"] || "",
  did_you_take_any_steps_to_remedy: data?.["actions_taken"] || "",
  notes: data?.["note_damage_area"] || "",
  claim_item_DA_status: data?.["status_customer_display"] || "",
  denial_short_summary: data?.["denial_short_summary"] || "",
  denial_reason_code_lookup:
    data?.["denial_reason_code_lookup"]?.["name"] || "",
  bp_status: data?.["bp_status"] || "",
});

const mapApiDocuments = (doc: any = {}): Documents => {
  const key = doc?.["key"] || "";
  const fileName = key.split("/").pop() || "";
  return {
    key,
    lastModified: doc?.["lastModified"] || "",
    size: doc?.["size"] || 0,
    url: doc?.["url"] || "",
    fileName,
  };
};
